import { ReactNode, useContext, useMemo, useState } from 'react';
import {
  DefaultTheme,
  ThemeContext,
  ThemeProvider as ThemeProviderStyledComponents,
} from 'styled-components';

import { theme as defaultTheme } from '@themes/main';

import { LAYOUT_OPTIONS } from '@common/types/ui';
import { LAYOUT_OPTION } from '@common/constants/ui';

interface ThemeProviderProps {
  children: ReactNode;
  layout?: LAYOUT_OPTIONS;
}

export const ThemeProvider = ({
  children,
  layout = LAYOUT_OPTION.COLUMN,
}: ThemeProviderProps) => {
  const upperTheme = useContext(ThemeContext);
  const [layoutPreference, setLayoutPreference] = useState(layout);
  const theme = useMemo(() => {
    const usedTheme = { ...(upperTheme || defaultTheme) } as DefaultTheme;

    usedTheme.layoutPreference = layoutPreference;
    usedTheme.setLayoutPreference = setLayoutPreference;

    return usedTheme;
  }, [layoutPreference, upperTheme]);

  return (
    <ThemeProviderStyledComponents theme={theme}>
      {children}
    </ThemeProviderStyledComponents>
  );
};
